import React, { FC } from "react";
import { useFormatter } from "kw/util/useFormatter";
import { ValueTypes } from "kw/api/zeus";
import { SummaryTable } from "./SummaryTable";

type TAdminPendingCancellationSection = {
  cancellation: Partial<ValueTypes["PolicyCancellationQuoteType"]>;
};
export const AdminPendingCancellationSection: FC<TAdminPendingCancellationSection> = ({
  cancellation,
}) => {
  const { formatString, formatCurrency } = useFormatter();

  const cancellationDetails = [
    {
      id: "amount-due",
      label: "Amount Due",
      value: formatCurrency(cancellation.amountDue),
    },
    {
      id: "total-fees",
      label: "Total Fees",
      value: formatCurrency(
        cancellation.fees.reduce((acc, fee) => acc + fee.amount, 0)
      ),
    },
  ];
  const cancellationDetailsDataString = cancellation.data;
  let cancellationDetailsData;

  if (cancellationDetailsDataString) {
    try {
      cancellationDetailsData = JSON.parse(cancellationDetailsDataString);
    } catch (error) {
      console.error("Failed to parse data JSON string:", error);
    }
  }

  if (cancellationDetailsData) {
    Object.entries(cancellationDetailsData).forEach(([key, value]) => {
      cancellationDetails.push({
        label: `Cancellation ${key
          .replace(/([A-Z])/g, " $1")
          .replace(/_/g, " ")
          .toLowerCase()}`,
        value: value,
      });
    });
  }

  return <SummaryTable data={cancellationDetails} type="QUOTE" />;
};
